export enum ApplicantSkillLevel {
  NOT_EXISTING = 'not-existing',
  EXISTING = 'existing',
  FUNDAMENTAL = 'fundamental',
  FUNDAMENTAL_PLUS = 'fundamental-plus',
  GOOD = 'good',
  VERY_GOOD = 'very-good',
  EXPERT = 'expert',
}

const SKILL_LEVEL_ORDER: ApplicantSkillLevel[] = [
  ApplicantSkillLevel.EXISTING,
  ApplicantSkillLevel.FUNDAMENTAL,
  ApplicantSkillLevel.FUNDAMENTAL_PLUS,
  ApplicantSkillLevel.GOOD,
  ApplicantSkillLevel.VERY_GOOD,
  ApplicantSkillLevel.EXPERT,
];

export function getSkillLevelOrder(
  level: ApplicantSkillLevel | null | undefined,
): number {
  if (!level || level === ApplicantSkillLevel.NOT_EXISTING) {
    return -1;
  }
  const index = SKILL_LEVEL_ORDER.indexOf(level);
  return index >= 0 ? index : -1;
}

export function meetsMinSkillLevel(
  level: ApplicantSkillLevel | null | undefined,
  minLevel: ApplicantSkillLevel,
): boolean {
  return getSkillLevelOrder(level) >= getSkillLevelOrder(minLevel);
}

export const FILTERABLE_SKILL_LEVELS = SKILL_LEVEL_ORDER;
